<template>
<div class="chapter">
<div class="inner_page">
<h1 class="tochead">Contents</h1>
<h2 class="toc_front"><a href="#/xhtml/09_Ack"><em class="italic">Acknowledgments</em></a></h2>
<h2 class="toc_chap"><a href="#/xhtml/10_Chapter_01"><span class="tochang">1.</span> The Sea Churned Red</a></h2>
<h2 class="toc_chap"><a href="#/xhtml/11_Chapter_02"><span class="tochang">2.</span> Total War</a></h2>
<h2 class="toc_chap"><span href="#/xhtml/12_Chapter_03" title="Link target outside of Sample"><span class="tochang">3.</span> ‘A Daring and Arduous Stunt’</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/13_Chapter_04" title="Link target outside of Sample"><span class="tochang">4.</span> The Suicide Club</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/14_Chapter_05" title="Link target outside of Sample"><span class="tochang">5.</span> Into the Cauldron</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/15_Chapter_06" title="Link target outside of Sample"><span class="tochang">6.</span> ‘The Firing was a Bit Severe …’</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/16_Chapter_07" title="Link target outside of Sample"><span class="tochang">7.</span> Eight VCs Before Dawn</span></h2>
<h2 class="toc_chap"><span href="#/xhtml/17_Chapter_08" title="Link target outside of Sample"><span class="tochang">8.</span> Aftermath</span></h2>
<h2 class="toc_back"><span href="#/xhtml/18_Notes" title="Link target outside of Sample"><em class="italic">Sources and Chapter Notes</em></span></h2>
<h2 class="toc_back1"><span href="#/xhtml/19_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography</em></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?66dd116c